module.exports = __webpack_public_path__ + "img/49eee37.svg";